import EfScrollAni from '@/efscrollani';
import { useProductStore } from '../../ProductStationProvider';
import { IPageStatus } from '../../config/IPageStatus';
import StatusA from './StatusA';
import StatusB from './StatusB';
import StatusC from './StatusC';
import './index.scss';
import getLocal from '@/app/utils/i18n';
import UsStatusA from './us/StatusA';

export default function ExampleProductA() {
    const { pageStatus } = useProductStore();

    if (typeof window !== 'undefined' && !window.AniContainer) {
        window.AniContainer = new EfScrollAni();
    }
    const { locale } = getLocal();

    return (
        <div className="page-product">
            {locale === 'jp' && (
                <div className="delta-3-max-series">
                    <StatusA />
                </div>
            )}
            {['us', 'ca'].includes(locale) && <>{pageStatus === IPageStatus.statusA && <UsStatusA />}</>}
        </div>
    );
}
